import { Dispatch, SetStateAction } from 'react'
import Modal from '..'
import ModalClose from '../ModalClose'
import DefaultButton from '../../Button/Button'
import { AddGuestRes } from '../../../interfaces/security'
import { showToast } from '../../../utils/toast'


const CopyCodeModal = ({ open, setIsOpen, guestInfo }: { open: boolean, setIsOpen: Dispatch<SetStateAction<boolean>>, guestInfo: AddGuestRes | null }) => {
  if (!guestInfo) return null;
  const { guest, property, host } = guestInfo
  const formattedDate = guest.startsAt ? new Date(guest.startsAt).toLocaleString() : 'N/A'
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(guest.code)
      showToast({
        description: 'Code copied to clipboard!',
        status: 'success',
        position: 'bottom-right',
      })
    } catch (err) {
      showToast({
        description: 'Failed to copy code',
        status: 'error',
        position: 'bottom-right',
      })
    }
  }

  return (
    <Modal
      open={open}
      close={() => setIsOpen(false)}
      widthClass="w-[calc(100%-32px)] sm:max-w-sm md:max-w-md"
    >
      <div className='flex justify-between items-center mb-4 sm:mb-6'>
        <p className='font-semibold text-base sm:text-xl break-words'>Guest destination details</p>
        <ModalClose onClick={() => setIsOpen(false)} className='flex-shrink-0 ml-2' />
      </div>
     <div className="flex flex-col gap-2 sm:gap-3 md:mt-4 mt-2 max-h-[60vh] overflow-y-auto">
  <div className="flex flex-col sm:flex-row gap-1 sm:gap-2">
    <p className="text-[#6C757D] font-medium text-xs sm:text-sm whitespace-nowrap">Name of guest:</p>
    <p className="font-medium text-xs sm:text-sm break-words">{guest.name}</p>
  </div>
  <div className="flex flex-col sm:flex-row gap-1 sm:gap-2">
    <p className="text-[#6C757D] font-medium text-xs sm:text-sm whitespace-nowrap">Date:</p>
    <p className="font-medium text-xs sm:text-sm break-words">{formattedDate}</p>
  </div>
  <div className="flex flex-col sm:flex-row gap-1 sm:gap-2">
    <p className="text-[#6C757D] font-medium text-xs sm:text-sm whitespace-nowrap">Resident:</p>
    <p className="font-medium text-xs sm:text-sm break-words">{host.name}</p>
  </div>
  <div className="flex flex-col sm:flex-row gap-1 sm:gap-2">
    <p className="text-[#6C757D] font-medium text-xs sm:text-sm whitespace-nowrap">Property:</p>
    <p className="font-medium text-xs sm:text-sm break-words">{property.address}</p>
  </div>
  <div className="flex flex-col sm:flex-row gap-1 sm:gap-2">
    <p className="text-[#6C757D] font-medium text-xs sm:text-sm whitespace-nowrap">Code:</p>
    <p className="font-medium text-xs sm:text-sm break-words font-mono bg-gray-50 px-2 py-1 rounded">{guest.code}</p>
  </div>
</div>

      <div className="flex flex-col-reverse sm:flex-row gap-3 sm:gap-4 justify-center sm:justify-end md:mt-5 mt-3">
        <DefaultButton
          buttonType="secondary"
          border="none"
          fontSize="14"
          onClick={() => setIsOpen(false)}
          className="w-full sm:w-auto"
        >
          Cancel
        </DefaultButton>
        <DefaultButton type="submit" fontSize="14" onClick={handleCopy} className="w-full sm:w-auto">
          Copy code
        </DefaultButton>
      </div>
    </Modal>
  )
}

export default CopyCodeModal
